import { apiPost } from './client';

export interface LlmCondomInstallResponse {
  data: {
    installCommand: string;
    note: string | null;
  };
}

export async function mintLlmCondomInstall(hostname?: string): Promise<LlmCondomInstallResponse> {
  return apiPost<LlmCondomInstallResponse>('/llm-condom/install', hostname ? { hostname } : {});
}
